import React, { useEffect, useState } from "react";
import { NotificationSummary } from "../../components";
import { NOTIFICATION_TYPE } from "../../types/enumerations/notifications";
var MaintenanceSummary = function (_a) {
    var countData = _a.countData;
    var _b = useState([]), subData = _b[0], setSubData = _b[1];
    var _c = useState({}), mainData = _c[0], setMainData = _c[1];
    useEffect(function () {
        var openCount = 0, scheduledCount = 0, closedCount = 0;
        (countData || []).forEach(function (countItem) {
            var _a, _b, _c;
            if (((_a = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === "ONGOING") {
                openCount += ((countItem === null || countItem === void 0 ? void 0 : countItem.count) || 0);
            }
            else if (((_b = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === "CLOSED") {
                closedCount += ((countItem === null || countItem === void 0 ? void 0 : countItem.count) || 0);
            }
            else if (((_c = countItem === null || countItem === void 0 ? void 0 : countItem.name) === null || _c === void 0 ? void 0 : _c.toUpperCase()) === "UPCOMING") {
                scheduledCount += ((countItem === null || countItem === void 0 ? void 0 : countItem.count) || 0);
            }
        });
        var mainDataObj = { title: "Ongoing", value: openCount };
        var subDataArray = [{ title: "Scheduled", value: scheduledCount }, { title: "Closed", value: closedCount }, { title: "", value: "" }];
        setSubData(subDataArray);
        setMainData(mainDataObj);
    }, [countData]);
    return React.createElement(NotificationSummary, { notificationType: NOTIFICATION_TYPE.MAINTENANCE, subData: subData, mainData: mainData });
};
export default MaintenanceSummary;
//# sourceMappingURL=index.js.map